// src/components/common/profile/PasswordChange.jsx
import React from "react";

export default function PasswordChange({
  isMyProfile,
  showPasswordFields,
  setShowPasswordFields,
  passwordVerified,
  verifyCurrentPassword,
  passwords,
  onChangePw,
  submitPasswordChange,
}) {
  if (!isMyProfile) return null;

  return (
    <div className="border-t border-b px-6 py-4">
      <div className="flex justify-between items-center">
        <h3 className="font-medium">비밀번호 변경</h3>
        {!showPasswordFields && (
          <button
            type="button"
            onClick={() => setShowPasswordFields(true)}
            className="px-3 py-1 rounded-md border text-sm hover:bg-gray-50"
          >
            변경
          </button>
        )}
      </div>

      {showPasswordFields && (
        <div className="mt-4 space-y-4">
          {/* 1단계: 현재 비밀번호 인증 */}
          {!passwordVerified ? (
            <>
              <label className="text-sm block">
                <div className="mb-1">현재 비밀번호 확인</div>
                <input
                  type="password"
                  name="current_password"
                  value={passwords.current_password}
                  onChange={onChangePw}
                  className="w-full border rounded-md px-3 py-2"
                  placeholder="현재 비밀번호를 입력하세요"
                />
              </label>

              <button
                type="button"
                onClick={verifyCurrentPassword}
                className="px-4 py-2 rounded-md border text-sm bg-gray-100 hover:bg-gray-200"
              >
                비밀번호 인증
              </button>
            </>
          ) : (
            <>
              {/* 2단계: 새 비밀번호 입력 */}
              <label className="text-sm block">
                <div className="mb-1">새 비밀번호</div>
                <input
                  type="password"
                  name="password"
                  value={passwords.password}
                  onChange={onChangePw}
                  className="w-full border rounded-md px-3 py-2"
                  placeholder="소문자+숫자 포함 6~64자"
                />
              </label>

              <label className="text-sm block">
                <div className="mb-1">비밀번호 확인</div>
                <input
                  type="password"
                  name="confirmPassword"
                  value={passwords.confirmPassword}
                  onChange={onChangePw}
                  className={`w-full border rounded-md px-3 py-2 ${
                    passwords.confirmPassword.length === 0
                      ? ""
                      : passwords.confirmPassword === passwords.password
                      ? "border-green-500"
                      : "border-red-500"
                  }`}
                  placeholder="새 비밀번호를 다시 입력하세요"
                />
              </label>

              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={submitPasswordChange}
                  className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm hover:bg-blue-700"
                >
                  비밀번호 변경
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowPasswordFields(false);
                  }}
                  className="px-4 py-2 rounded-md border text-sm hover:bg-gray-50"
                >
                  취소
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
